import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import PromptService from '../../../services/prompt-service';

const useRunPrompt = ({ onSuccess }: { onSuccess: (data: string) => void }) => {
  return useMutation({
    mutationFn: async ({
      promptId,
      text,
    }: {
      promptId: number;
      text: string;
    }) => {
      const data = await PromptService.runPrompt(promptId, text);
      return data;
    },
    onSuccess: (data) => {
      onSuccess(data);
    },
    onError: (error) => {
      toast.error('Failed to run prompt. Please try again.');
      console.error('Failed to run prompt:', error);
    },
  });
};

export default useRunPrompt;
